import { Component, ElementRef, ViewChild } from '@angular/core';
import { API_End_Point } from '../../../../Services/API_End_Point';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { SharedService } from '../../../../Services/shared.service';
import * as faceapi from 'face-api.js';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'app-dialog-mychild',
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule],
  templateUrl: './dialog-mychild.component.html',
  styleUrl: './dialog-mychild.component.css'
})
export class DialogMychildComponent {
  @ViewChild('CameraId') _camera!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvas') _canvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('frame') _frame!: ElementRef<HTMLDivElement>;
  @ViewChild('fileInput') fileInput!: ElementRef;
  capturedImage: string | null = null;
  faceCount: any = null;
  msg: any = null;
  isShowCamera: any = false;
  ChildList: any[] = [];
  object: any;
  isAddChild: boolean = false;
  IsShow_For_AddChild: boolean = false;
  isEdit: boolean = false;
  attemptCount = 0;
  MAX_ATTEMPTS = 5;
  isManualUplode: boolean = false;
  usingFile: boolean = false;
  constructor(private _svc: SharedService, private _fb: FormBuilder, private _router: Router, private _dialogRef: DialogRef) {

  }

  ngOnInit() {

    // this._svc.get_Login_Status().subscribe(x => {
    //   this.PREP_UserInfo = x;
    // })
    setTimeout(() => {
      this.fetchChildList();
      this.GenerateForm();
    }, 100);


  }
  GenerateForm() {
    this.object = this._fb.group({
      id: [null],
      childName: [null, [Validators.required, Validators.minLength(2)]],
      classId: [null, [Validators.required]],
      photo: [null, [Validators.required]],
      SchName: [null, [Validators.required, Validators.minLength(2)]]
    });
  }
  fetchChildList(callback?: () => void) {
    this._svc.GET(API_End_Point.GetChild).subscribe((res: any) => {
      if (res && res.result === 'success') {
        this.ChildList = res.data;
        if (callback) callback();
        if (this.ChildList.length == 1) {
          this._svc.updateChildInfo(this.ChildList[0]);
        }
        this.IsShow_For_AddChild = (this.ChildList.length < 5 ? true : false);
      } else {
        this.ChildList = [];
        if (callback) callback();
      }
    });
  }
  saveChildRecord() {
    if (this.object.invalid) {
      this.object.markAllAsTouched();
      this.object.markAsDirty();
      return;
    }
    if (this.ChildList.length >= 5 && this.object.value.id == null) {
      this._svc.Notification('error', 'You can only add up to 5 children.');
      return;
    }


    const childData = this.object.value;
    this._svc.POST(childData, API_End_Point.AddChild).subscribe((res: any) => {
      if (res && res.result === 'success') {
        if (childData.id && childData.id > 0) {
          this._svc.Notification("success", "Child updated successfully");
        } else {
          this._svc.Notification("success", "Child added successfully");
        }
        this.fetchChildList(() => {
          const activeChild = this.ChildList.find((c: any) => c.ActiveStudent === true);
          if (activeChild && activeChild.StudentId == childData.id) {
            this._svc.updateChildInfo(activeChild);
          }
        });
        this.object.reset();
        this.capturedImage = null;
        this.isShowCamera = false;
        this.isAddChild = false;
        this.ngOnDestroy();
      } else {
        this._svc.Notification("error", "Failed to add child. Please try again.");
      }
    });
  }

  Switch(childId: any) {
    this._svc.GET(API_End_Point.switchChild(childId)).subscribe((res: any) => {
      if (res && res.result === 'success') {
        debugger
        this._svc.Notification('success', 'Switched to child account successfully');

        this.fetchChildList(() => {
          debugger
          const activeChild = this.ChildList.find((c: any) => c.ActiveStudent === true);
          if (activeChild && activeChild.StudentId == childId) {
            this.updateChildInfo(activeChild);
          }
          if (this._router.url == "/exam" || this._router.url == '/required-configuration') {
            window.location.href = "/dashboard";
          }
          this._dialogRef.close({ result: 'close' });
        });

        //setTimeout(() => {      
        //if (this._router.url == "/exam" || this._router.url == '/required-configuration') {
        //window.location.href = "/dashboard";
        //}
        //this._dialogRef.close({ result: 'close' });
        //}, 100)

      }
    });
  }



  updateChildInfo(child: any) {

    let userInfo = JSON.parse(localStorage.getItem("PREP_UserInfo") || '{}');
    if (userInfo) {
      userInfo.childId = child.StudentId;
      userInfo.childName = child.childName;
      userInfo.classId = child.ClassId;
      userInfo.profilePic = child.Photo;
      userInfo.className = child.className;
      userInfo.schName = child.schName;
    }
    localStorage.setItem("PREP_UserInfo", JSON.stringify(userInfo));
    this._svc.get_Login_Status();


  }
  Edit(childId: any) {
    debugger
    const child = this.ChildList.find((c: any) => c.StudentId === childId);
    if (child) {
      this.object.patchValue({
        id: child.StudentId,
        childName: child.childName,
        classId: child.ClassId,
        photo: child.Photo,
        //  gender: child.Gender,
        ActiveStudent: child.activeStudent,
        SchName: child.SchName

      });
      this.isAddChild = true;
      this.isEdit = true
    }
  }



  openCamera(): void {
    this.capturedImage = null;
    this.isShowCamera = true
    this.object.controls['photo'].setValue(null);
    this._svc.openCamera(this._camera);
    this.attemptCount = 0;
  }

  // async captureImage() {
  //   debugger
  //   const base64ToImage = (base64: string): Promise<HTMLImageElement> => {
  //     return new Promise((resolve, reject) => {
  //       const img = new Image();
  //       img.crossOrigin = 'anonymous';
  //       img.src = base64;
  //       img.onload = () => resolve(img);
  //       img.onerror = (err) => reject('Failed to load image: ' + err);
  //     });
  //   };
  //   const canvas = this._canvas.nativeElement;
  //   const video = this._camera.nativeElement;
  //   const context = canvas.getContext('2d');

  //   if (context) {

  //     const top = this._frame.nativeElement.offsetTop;
  //     const left = this._frame.nativeElement.offsetLeft;
  //     const height = this._frame.nativeElement.offsetHeight;
  //     const width = this._frame.nativeElement.offsetWidth;

  //     const tempCanvas = document.createElement('canvas');
  //     tempCanvas.width = video.videoWidth;
  //     tempCanvas.height = video.videoHeight;
  //     const tempCtx = tempCanvas.getContext('2d');
  //     tempCtx?.drawImage(video, 0, 0, tempCanvas.width, tempCanvas.height);


  //     // Crop from original size to match frame

  //     const cropX = left * (video.videoWidth / video.clientWidth);
  //     const cropY = top * (video.videoHeight / video.clientHeight);
  //     const cropWidth = width * (video.videoWidth / video.clientWidth);
  //     const cropHeight = height * (video.videoHeight / video.clientHeight);

  //     context.drawImage(tempCanvas, cropX, cropY, cropWidth, cropHeight, 0, 0, canvas.width, canvas.height);

  //     //this.capturedImage = canvas.toDataURL('image/png');

  //     //const dstImg = await base64ToImage(this.capturedImage);

  //     // debugger;
  //     // const detection = await faceapi.detectSingleFace(dstImg)
  //     //   .withFaceLandmarks()
  //     //   .withFaceDescriptor();
  //     // debugger
  //     const detections = await faceapi.detectAllFaces(
  //       this._canvas.nativeElement,
  //       new faceapi.SsdMobilenetv1Options()
  //     );
  //     this.msg = "";

  //     if (detections.length == 1) {
  //       this.capturedImage = canvas.toDataURL('image/png'); // base64 image
  //       this.object.patchValue({ photo: this.capturedImage });
  //       this.ngOnDestroy();
  //       this.attemptCount = 0; 
  //     }

  //     else {
  //        this.attemptCount++;
  //       this.msg = this._svc.FaceDetections_Message(detections)
  //       if(this.attemptCount < this.MAX_ATTEMPTS)
  //       {
  //         this._svc.Notification('error', "Failed to detect face. Please try again.");
  //       }

  //       //this._svc.Notification("error", detections.length + "");
  //       this.capturedImage = null;



  //     if (this.attemptCount < this.MAX_ATTEMPTS) {
  //     //  setTimeout(() => this.captureImage(), 1000); 
  //     } else {

  //       if (true) {
  //        // this._svc.Notification('success', "Accepted after 3 attempts with best match.");
  //         this.capturedImage = canvas.toDataURL('image/png');
  //         this.object.patchValue({ photo: this.capturedImage });
  //         this.ngOnDestroy();
  //       } else {
  //        // this._svc.Notification('error', "Failed after 3 attempts. Please try again.");
  //       }

  //       this.attemptCount = 0; // Reset counter after 3 attempts
  //     }

  //     }
  //   }
  // }
  // ==========================================


  async captureImage() {
    debugger
    this._svc.Show_Loader();

    // ✅ Force UI repaint before heavy work
    await new Promise(resolve => setTimeout(resolve, 100));

    const canvas = this._canvas.nativeElement;
    const video = this._camera.nativeElement;
    const context = canvas.getContext('2d');
    debugger
    if (!context) {
      this._svc.Hide_Loader();
      return;
    }

    // Frame dimensions
    const top = this._frame.nativeElement.offsetTop;
    const left = this._frame.nativeElement.offsetLeft;
    const height = this._frame.nativeElement.offsetHeight;
    const width = this._frame.nativeElement.offsetWidth;

    // Temp canvas
    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = video.videoWidth;
    tempCanvas.height = video.videoHeight;
    const tempCtx = tempCanvas.getContext('2d');
    tempCtx?.drawImage(video, 0, 0, tempCanvas.width, tempCanvas.height);

    // Original crop dimensions
    const cropX = left * (video.videoWidth / video.clientWidth);
    const cropY = top * (video.videoHeight / video.clientHeight);
    const cropWidth = width * (video.videoWidth / video.clientWidth);
    const cropHeight = height * (video.videoHeight / video.clientHeight);

    // Draw the original cropped image on display canvas
    context.drawImage(tempCanvas, cropX, cropY, cropWidth, cropHeight, 0, 0, canvas.width, canvas.height);

    try {
      // ✅ EXPANDED DETECTION AREA
      const padding = 0.4;
      const expandedCropX = Math.max(0, cropX - cropWidth * padding);
      const expandedCropY = Math.max(0, cropY - cropHeight * padding);
      const expandedCropWidth = Math.min(
        video.videoWidth - expandedCropX,
        cropWidth * (1 + padding * 2)
      );
      const expandedCropHeight = Math.min(
        video.videoHeight - expandedCropY,
        cropHeight * (1 + padding * 2)
      );

      // Create detection canvas with expanded area
      const detectionCanvas = document.createElement('canvas');
      detectionCanvas.width = expandedCropWidth;
      detectionCanvas.height = expandedCropHeight;
      const detectionCtx = detectionCanvas.getContext('2d');

      if (!detectionCtx) {
        this._svc.Hide_Loader(); // Hide loader if detection context fails
        return;
      }

      // Draw expanded area on detection canvas
      detectionCtx.drawImage(
        tempCanvas,
        expandedCropX, expandedCropY, expandedCropWidth, expandedCropHeight,
        0, 0, detectionCanvas.width, detectionCanvas.height
      );

      //Detect faces WITH LANDMARKS (eyes, nose, mouth positions)
      const detections = await faceapi
        .detectAllFaces(
          detectionCanvas,
          new faceapi.SsdMobilenetv1Options({ minConfidence: 0.2 })
        )
        .withFaceLandmarks();

      this.msg = "";

      //Check if exactly 1 face with proper orientation
      if (detections.length === 1) {
        const landmarks = detections[0].landmarks;

        //Get eye positions
        const leftEye = landmarks.getLeftEye();
        const rightEye = landmarks.getRightEye();

        // Calculate average Y position of eyes
        const leftEyeY = leftEye.reduce((sum, point) => sum + point.y, 0) / leftEye.length;
        const rightEyeY = rightEye.reduce((sum, point) => sum + point.y, 0) / rightEye.length;

        // Get nose position
        const nose = landmarks.getNose();
        const noseY = nose.reduce((sum, point) => sum + point.y, 0) / nose.length;

        //VALIDATION: Eyes should be ABOVE nose (proper orientation)
        const averageEyeY = (leftEyeY + rightEyeY) / 2;
        const isProperOrientation = averageEyeY < noseY;

        //VALIDATION: Face shouldn't be too tilted (eyes at similar height)
        const eyeHeightDifference = Math.abs(leftEyeY - rightEyeY);
        const faceHeight = detections[0].detection.box.height;
        const tiltThreshold = faceHeight * 0.25; // Max 15% tilt
        const isNotTooTilted = eyeHeightDifference < tiltThreshold;

        if (isProperOrientation && isNotTooTilted) {
          //VALID FACE - Capture image
          this.capturedImage = canvas.toDataURL('image/png');
          this.object.patchValue({ photo: this.capturedImage });
          this.ngOnDestroy();
          this.attemptCount = 0;
          this._svc.Notification('success', 'Face captured successfully!');
          this._svc.Hide_Loader(); // ✅ Hide loader on success
          return;
        } else {
          // INVALID ORIENTATION

          this.isManualUplode = true;
          this.attemptCount++;
          if (!isProperOrientation) {
            this.msg = 'Please keep your face upright (not upside down).';
          } else if (!isNotTooTilted) {
            this.msg = 'Please keep your head straight (not tilted).';
          }
          this.capturedImage = null;
        }
      } else {
        //Not exactly 1 face
        this.isManualUplode = true;
        this.attemptCount++;
        this.msg = this._svc.FaceDetections_Message(detections);
        this.capturedImage = null;
      }

      if (this.attemptCount < this.MAX_ATTEMPTS) {
        this._svc.Notification('warning',
          `Attempt ${this.attemptCount}/${this.MAX_ATTEMPTS}: ${this.msg} Please try again.`
        );
        this._svc.Hide_Loader(); // ✅ Hide loader after warning
      } else {
        // After 3 attempts - accept if ANY properly oriented face found
        if (detections.length > 0) {
          const hasProperFace = detections.some(det => {
            const landmarks = det.landmarks;
            const leftEye = landmarks.getLeftEye();
            const rightEye = landmarks.getRightEye();
            const nose = landmarks.getNose();

            const leftEyeY = leftEye.reduce((sum, point) => sum + point.y, 0) / leftEye.length;
            const rightEyeY = rightEye.reduce((sum, point) => sum + point.y, 0) / rightEye.length;
            const noseY = nose.reduce((sum, point) => sum + point.y, 0) / nose.length;
            const averageEyeY = (leftEyeY + rightEyeY) / 2;

            return averageEyeY < noseY;
          });

          if (hasProperFace) {
            this._svc.Notification('info', 'Accepting image after 3 attempts.');
            this.capturedImage = canvas.toDataURL('image/png');
            this.object.patchValue({ photo: this.capturedImage });
            this.ngOnDestroy();
            this._svc.Hide_Loader(); // Hide loader on final success
          } else {
            this._svc.Notification('error', 'No properly oriented face detected. Please keep your face upright.');
            this._svc.Hide_Loader(); // Hide loader on error
          }
        } else {
          this._svc.Notification('error', 'No face detected. Please try again with better lighting.');
          this._svc.Hide_Loader(); //Hide loader on error
        }
        this.attemptCount = 0;
      }

    } catch (error) {
      console.error('Face detection error:', error);
      this._svc.Notification('error', 'Error detecting face. Please try again.');
      this._svc.Hide_Loader(); //Hide loader on exception
    }
  }
  ngOnDestroy(): void {

    this.isShowCamera = false;
    this.isManualUplode = true;
    this._svc.closeCamera();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this._svc.loadModels();
    }, 100);
  }




  Cancel() {
    this._dialogRef.close({ result: 'close' });
  }






  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
    this.usingFile = true;

  }


  onFileSelected(event: any): void {
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    // Validate file type
    if (!file.type.startsWith('image/')) {
      this._svc.Notification('error', 'Please select an image file only.');
      return;
    }

    // Validate file size (max 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    if (file.size > maxSize) {
      this._svc.Notification('error', 'Image size should not exceed 5MB.');
      return;
    }

    this._svc.Show_Loader();

    const reader = new FileReader();

    reader.onload = async (e: any) => {
      try {
        const img = new Image();
        img.src = e.target.result;

        img.onload = async () => {
          //  Resize image to standard dimensions (150x180)
          const canvas = document.createElement('canvas');
          canvas.width = 150;
          canvas.height = 180;
          const ctx = canvas.getContext('2d');

          if (!ctx) {
            this._svc.Hide_Loader();
            this._svc.Notification('error', 'Failed to process image.');
            return;
          }

          // Draw image on canvas (will auto-resize)
          ctx.drawImage(img, 0, 0, 150, 180);

          //  OPTIONAL: Face detection on uploaded image
          // Agar aap uploaded image pe bhi face detection chahte ho
          try {
            const detections = await faceapi
              .detectAllFaces(
                canvas,
                new faceapi.SsdMobilenetv1Options({ minConfidence: 0.2 })
              )
              .withFaceLandmarks();

            if (detections.length === 0) {
              // No face detected - but still allow upload with warning
              this._svc.Notification('warning',
                'No clear face detected in uploaded image.');
            } else if (detections.length > 1) {
              this._svc.Notification('warning',
                'Multiple faces detected. Please upload image with single person.');
              this._svc.Hide_Loader();
              return;
            } else {
              this._svc.Notification('success', 'Face detected successfully!');
            }
          } catch (error) {
            console.warn('Face detection skipped for uploaded image:', error);
            // Continue anyway - face detection is optional for manual upload
          }

          // Convert to base64 and save
          const base64Image = canvas.toDataURL('image/png');
          this.capturedImage = base64Image;
          this.object.patchValue({ photo: base64Image });

          this._svc.Hide_Loader();
          this._svc.Notification('success', 'Image uploaded successfully!');
        };

        img.onerror = () => {
          this._svc.Hide_Loader();
          this._svc.Notification('error', 'Failed to load image. Please try another file.');
        };

      } catch (error) {
        console.error('File processing error:', error);
        this._svc.Hide_Loader();
        this._svc.Notification('error', 'Error processing image. Please try again.');
      }
    };

    reader.onerror = () => {
      this._svc.Hide_Loader();
      this._svc.Notification('error', 'Failed to read file. Please try again.');
    };

    reader.readAsDataURL(file);

    // ✅ Reset file input so same file can be selected again
    event.target.value = '';
  }
}